var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 73,
    viewBox: "0 0 200 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.417 61.6319C182.813 61.6319 180.556 62.3264 178.299 63.3681C177.431 56.9444 171.875 51.9097 165.278 51.9097C160.764 51.9097 156.771 54.1667 154.34 57.6389C153.819 52.0833 149.132 47.5694 143.403 47.5694C141.146 47.5694 138.889 48.2639 137.153 49.4792C132.986 43.4028 126.215 41.3194 118.75 42.3611C117.708 32.2917 109.549 24.3056 99.3056 23.6111C99.3056 22.9167 99.4792 22.2222 99.4792 21.7014C99.4792 11.2847 90.9722 2.77778 80.5556 2.77778C75 2.77778 70.1389 5.03472 66.6667 8.85417C63.3681 3.47222 57.6389 0 51.2153 0C41.4931 0 33.6806 7.8125 33.5069 17.5347C31.7708 16.8403 29.8611 16.6667 27.9514 16.6667C18.5764 16.6667 10.9375 24.3056 10.9375 33.6806C10.9375 37.6736 12.3264 41.1458 14.4097 44.0972C10.4167 46.875 7.8125 51.5625 7.8125 56.9444C7.8125 58.5069 7.98611 59.8958 8.33333 61.2847C3.64583 62.5 0 67.0139 0 72.2222H200C198.09 66.1458 192.188 61.6319 185.417 61.6319Z",
    fill: "#D1CBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 72.2222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d29b9f2b9cba897d8e3f137bbeea68f4.svg";
export { ForwardRef as ReactComponent };